import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fb61a7e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "opModal"
}
const _hoisted_2 = { class: "modalCloser" }
const _hoisted_3 = { class: "pointer ml-5" }
const _hoisted_4 = { class: "modalHeader" }
const _hoisted_5 = { class: "leadHeader" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Seleziona centro", -1))
const _hoisted_9 = {
  value: null,
  disabled: ""
}
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "modalBody" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "modalFooter" }
const _hoisted_14 = { class: "text-right" }
const _hoisted_15 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_make_prenotazione_calendar = _resolveComponent("make-prenotazione-calendar")!

  return (_ctx.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createElementVNode("i", {
              class: "fa fa-times",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_localized_text, {
                localizedKey: "Fissa appuntamento",
                text: "Fissa appuntamento"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("select", {
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCentro) = $event))
            }, [
              _createElementVNode("option", _hoisted_9, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Seleziona",
                  text: "Seleziona"
                })
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.centri, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item,
                  key: item.identifier
                }, _toDisplayString(item.name), 9, _hoisted_10))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.selectedCentro]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_ctx.showCalendar)
            ? (_openBlock(), _createBlock(_component_make_prenotazione_calendar, {
                key: 0,
                "user-identifier": _ctx.selectedCentroIdentifier,
                modelValue: _ctx.vm,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.vm) = $event))
              }, null, 8, ["user-identifier", "modelValue"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("label", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Note",
                text: "Note"
              })
            ]),
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control",
              placeholder: "Note",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.vm.note) = $event))
            }, null, 512), [
              [_vModelText, _ctx.vm.note]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary ml-2",
              disabled: !_ctx.canSave,
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Conferma",
                text: "Conferma"
              })
            ], 8, _hoisted_15)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}